import { Accomodation } from "./Accomodation"
import { Advertising } from "./Advertising"
import { AiEnhancement } from "./AiEnhancement"
import { Bag } from "./Bag"
import { Balloon } from "./Balloon"
import { Boat } from "./Boat"
import { Booking } from "./Booking"
import { Brush } from "./Brush"
import { Calendar } from "./Calendar"
import { Cancel } from "./Cancel"
import { Canoeing } from "./Canoeing"
import { Card } from "./Card"
import { Chaise } from "./Chaise"
import { CheckedCircle } from "./CheckedCircle"
import { ConfirmDisclaimer } from "./ConfirmDisclaimer"
import { Dashboard } from "./Dashboard"
import { Delete } from "./Delete"
import { DivingMask } from "./DivingMask"
import { Dock } from "./Dock"
import { EBike } from "./EBike"
import { Experiences } from "./Experiences"
import { FAQ } from "./FAQ"
import { File } from "./File"
import { Finances } from "./Finances"
import { Fish } from "./Fish"
import { FishingBoat } from "./FishingBoat"
import { Food } from "./Food"
import { Fuel } from "./Fuel"
import { Gallery } from "./Gallery"
import { GolfMobile } from "./GolfMobile"
import { Google } from "./Google"
import { HorseRiding } from "./HorseRiding"
import { Insurance } from "./Insurance"
import { Investment } from "./Investment"
import { Island } from "./Island"
import { License } from "./License"
import { Link } from "./Link"
import { Maintenance } from "./Maintenance"
import { Marketing } from "./Marketing"
import { Membership } from "./Membership"
import { Menu } from "./Menu"
import { Messages } from "./Messages"
import { Notification } from "./Notification"
import { Other } from "./Other"
import { Paddling } from "./Paddeling"
import { PaperMap } from "./PaperMap"
import { Parachute } from "./Parachute"
import { Password } from "./Password"
import { Play } from "./Play"
import { Profit } from "./Profit"
import { QR } from "./QR"
import { RopeSkipping } from "./RopeSkipping"
import { Scooter } from "./Scooter"
import { Settings } from "./Settings"
import { Staff } from "./Staff"
import { Support } from "./Support"
import { Surfing } from "./Surfing"
import { SurfingBoard } from "./SurfingBoard"
import { Tent } from "./Tent"
import { Training } from "./Training"
import { User } from "./User"
import { UserCircle } from "./UserCircle"
import { WaterSkiing } from "./WaterSkiing"
import { Weather } from "./Weather"
import { Yacht } from "./Yacht"
import { FillStar } from "./FillStar"
import { InfoIcon } from "./Info"

const icons = {
  fillStar: FillStar,
  island: Island,
  divingMask: DivingMask,
  training: Training,
  fishingBoat: FishingBoat,
  paperMap: PaperMap,
  canoeing: Canoeing,
  fish: Fish,
  ropeSkipping: RopeSkipping,
  yacht: Yacht,
  balloon: Balloon,
  surfingBoard: SurfingBoard,
  surfing: Surfing,
  paddling: Paddling,
  parachute: Parachute,
  horseRiding: HorseRiding,
  waterSkiing: WaterSkiing,
  chaise: Chaise,
  golfMobile: GolfMobile,
  tent: Tent,
  dock: Dock,
  booking: Booking,
  gallery: Gallery,
  dashboard: Dashboard,
  calendar: Calendar,
  messages: Messages,
  marketing: Marketing,
  finances: Finances,
  boat: Boat,
  notification: Notification,
  weather: Weather,
  experiences: Experiences,
  support: Support,
  faq: FAQ,
  qr: QR,
  eBike: EBike,
  scooter: Scooter,
  settings: Settings,
  user: User,
  password: Password,
  brush: Brush,
  card: Card,
  license: License,
  investment: Investment,
  menu: Menu,
  profit: Profit,
  fuel: Fuel,
  maintenance: Maintenance,
  bag: Bag,
  membership: Membership,
  insurance: Insurance,
  accomodation: Accomodation,
  other: Other,
  advertising: Advertising,
  food: Food,
  staff: Staff,
  aiEnhancement: AiEnhancement,
  checkedCircle: CheckedCircle,
  confirmDisclaimer: ConfirmDisclaimer,
  link: Link,
  play: Play,
  file: File,
  google: Google,
  delete: Delete,
  userCircle: UserCircle,
  cancel: Cancel,
  info: InfoIcon,
}

export const DSIcon = ({ name, ...props }) => {
  const Icon = icons[name]
  return <Icon {...props} />
}
